module.exports = __webpack_public_path__ + "media/images/countryrect/brittany-cb44493d576e0d409cabb2da81d7819d.svg";